import React from "react";
import { ProjectColors } from "../../../interfaces/projects";
import "./pagination.scss";

interface PaginationProps {
  currentPage: number;
  postsPerPage: number;
  totalPosts: number;
  paginate: (pageNumber: number) => void;
  colors: ProjectColors;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  postsPerPage,
  totalPosts,
  paginate,
  colors,
}) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
    pageNumbers.push(i);
  }

  console.warn();

  return (
    <React.Fragment>
      {pageNumbers.length > 1 && (
        <div className="pagination-container">
          <nav>
            <ul className="pagination">
              {pageNumbers.map((number: number) => (
                <li
                  className={`page-item ${
                    currentPage === number ? "selected" : ""
                  }`}
                  key={number}
                  style={{
                    backgroundColor:
                      currentPage === number ? colors.primary : "#a1a09f",
                    color: colors.contrast,
                  }}
                >
                  <a
                    onClick={() => paginate(number)}
                    className={`page-link ${
                      currentPage === number ? "font-bold" : "font-medium"
                    }`}
                  >
                    {number}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      )}
    </React.Fragment>
  );
};

export default Pagination;
